import React from "react";
import { Styled } from "./styles";
import useQueryOrganizations from "@/hooks/queries/useQueryOrganizations";
import Organization from "@/components/settings/organizations/organization";
import SectionTitle from "@/components/ui/section-title";
import { Box, CircularProgress, useTheme } from "@mui/material";
import { i18n } from "@/utils/i18n";
import { useNavigate } from "react-router-dom";
import { log } from "@/utils/logger";
import api from "@/config/api";
import storage from "@/utils/storage";
import { auth } from "@/config/firebase";
import useGlobalSpinner from "@/context/spinner";
import useLocale from "@/context/locale";

const Organizations: React.FC = () => {
    useLocale(state => state.locale);
    const { data: organizations, isLoading } = useQueryOrganizations();
    const theme = useTheme();
    const white = theme.palette.common.white;

    const navigate = useNavigate();
    const setGlobalLoading = useGlobalSpinner(state => state.setLoading);

    const onSelect = async (oid: string) => {
        try {
            setGlobalLoading(true);
            storage.setItem("oid", oid);

            await api.post("/users/set-claims", { data: { oid } });
            await auth.currentUser?.reload();
            navigate(`/organizations/${oid}/reports`);
        } catch (e) {
            log.error(e);
        } finally {
            setGlobalLoading(false);
        }
    };

    if (isLoading || !organizations) {
        return (
            <Styled.Page center={true}>
                <CircularProgress />
            </Styled.Page>
        );
    }

    return (
        <Styled.Page center={true}>
            <Box>
                <SectionTitle style={{ color: white }} title={i18n.t("chooseMunicipality")} />
                <ul style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {Object.entries(organizations).map(i => {
                        return (
                            <Organization
                                textStyle={{ color: white }}
                                iconStyle={{ color: white }}
                                key={i[0]}
                                data={i}
                                onSelect={onSelect}
                            />
                        );
                    })}
                </ul>
            </Box>
        </Styled.Page>
    );
};

export default Organizations;
